// Generated by Typewriter / DataModelGenerator.tst
// https://frhagn.github.io/Typewriter/pages/documentation.html

import { TxnTemplateIntervalType } from './TxnTemplateIntervalType';

// AbilityIntranet.Data.Intranet.TxnTemplateInterval
export class TxnTemplateInterval {
    public amount: number = 0;
    public unit: TxnTemplateIntervalType = null;
    public next: Date = null;
    public end: Date = null;
}


    



